import classNames from 'classnames';
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { EVO } from '../EVO';
import { usePTTable } from './PTTable';

const RowContext = createContext();

export const PTRowBase = ({ index, style, item, row }) => {
    const { activeRows, setActiveRows, listRef, rowSize, rowSizes, setRowSizes } = usePTTable();

    const toggleActive = () => {
        if (activeRows.indexOf(index) === -1) {
            setActiveRows(a => [...a, index]);
        }
        else {
            setActiveRows(activeRows.filter(a => a !== index));
        }

        if (listRef.current) {
            listRef.current.resetAfterIndex(index);
        }
    };

    const rowRef = useRef();

    useEffect(() => {
        if (rowRef.current && EVO.any(rowRef.current.children)) {
            let height = 0;
            for (let i = 0; i < rowRef.current.children.length; i++) {
                height += rowRef.current.children[i].offsetHeight;
            }

            const val = Math.max(height, rowSize);
            if (rowSizes[index] !== val) {
                if (listRef.current) {
                    listRef.current.resetAfterIndex(index);
                }

                setRowSizes(rs => ({
                    ...rs,
                    [index]: val
                }));
            }
        }
    }, []);

    return <RowContext.Provider value={{ item, toggleActive, active: activeRows.indexOf(index) > -1, index }}>
        <div ref={rowRef} style={style} className={classNames(`pt-table-outer-row`, {
        'pt-row-even': index % 2 === 0
    })}>
        {row()}
        </div>
    </RowContext.Provider>
};

export const usePTRow = () => useContext(RowContext);

export const PTRow = ({ children, ...props }) => {
    return <div className="pt-table-row">
        {children}
    </div>
};

export const PTRowExpandable = ({ children, expand, ...props }) => {
    const { active } = usePTRow();
    return <div className="pt-table-row-expandable">
        <PTRow {...props}>
            {children}
        </PTRow>
        {active && <div className="pt-table-row-expanded-section">
            {expand}
        </div>}
    </div>
};

export const PTHeader = ({ children, style, ...props }) => {
    return <div className="pt-table-header" style={style}>
        {children}
    </div>
};

export const PTCell = ({ children, width, grow, shrink, ...props }) => {
    const style = {
        width: width
    };

    return <div style={style} className={classNames(`pt-table-cell`, {
        'shrink': !!shrink,
        'grow': !!grow
    })} {...props}>
        {children}
    </div>
};


// WEBPACK FOOTER //
// ./src/components/PTRow.js